import { Component, HostListener, OnInit } from '@angular/core'
import { RestServices } from '../../../../services/rest.services'
import { AuthService } from '../../../../services/auth.services'
import { ModalService } from '../../../../services/modal.service'
import { FormBuilder, FormGroup } from '@angular/forms'
import { SharedServices } from '../../../../services/shared.services'
import * as moment from 'moment'
import { ActivatedRoute } from '@angular/router'
import { imageStatusUrl, ordinalSuffixOf } from '../../../../../helper/common'
import { notification } from 'onsenui'
import { DatepickerHelper } from '../../../../../helper/datepicker.helper'

@Component({
    selector: 'app-modal-detail-client-compliance',
    templateUrl: './modal-detail-client-compliance.component.html',
    styleUrls: [
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/main-view.component.css',
        './modal-detail-client-compliance.component.css',
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalDetailClientComplianceComponent implements OnInit {

    complianceForm: FormGroup
    ModalNewCompliance = 'hidden'
    ModalEditCompliance = 'hidden'
    dialogNewCompliance = ''
    dialogEditCompliance = ''
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    routerLink
    optionsVisitDate: any = { viewMode: 'days', ...DatepickerHelper.BASE_OPTIONS }
    modelVisitDate
    filterLang: string
    valueVisitDate
    timestampDate
    StaffId
    showStaff = 'hidden'
    arrStaff
    optionArrCopy
    showOption: any
    styleVisibility: any

    receiveDeviceClass
    chewieComplianceClass
    ChewiePassedClass
    ElasticComplianceClass
    ElasticCompliancePassedClass
    idClient
    modelAlignerFit
    detailComplice
    ElasticTypeLeftClass
    ElasticRightClass
    compileIdEdit
    en = {}
    showEN = true
    ratioInput = 'hidden'


    valueUsage: number = 0
    valueRatio: number = 0
    valueUsageCurent: number = 0
    valueRatioCurent: number = 0
    valueReceiveDevice
    valuechewieCompliance
    valueChewiePassed
    valueElasticCompliance
    valueElasticPassed
    valueAlignerFit
    valueStaff
    valueStaffDeleted
    valueVisitDateApi
    valueElasticTypeLeft
    valueElasticTypeRight
    max: number = 56
    listAligner
    listClient
    activeAligner
    startDate
    endDate
    phaseAligner
    idAligner
    paramsSearch
    filterAligner

    hiddenModalAligner = 'hidden'
    optionArrCopyAligner
    styleVisibilityAligner
    startDateEdit
    endDateEdit
    phaseAlignerEdit

    alignerPreviewData
    loadAlignerPreviewData = false
    alignerPreviewDigest
    hiddenModalPreviewData = 'hidden'

    hiddenModalFilterAligner = 'hidden'
    paramsSearchAligner
    optionArrCopyAlignerCompliance
    listAlignerCompliance
    alignerActiveFilter = 'all'

    isShowConfirm: Boolean = false
    view: any
    thisView: any = 'client-compliance'

    hostKeyboard: String = 'ModalDetailClientComplianceComponent-hostKeyboard'
    defaultStaff

    arrayReceiveDevice = [
        { id: 0, name: 'ReceiveDevice-Yes', values: 1 },
        { id: 1, name: 'ReceiveDevice-No', values: 0 },
    ]

    arrayChewieCompliance = [
        { id: 'good', name: 'ChewieCompliance-Good', values: 'good' },
        { id: 'normal', name: 'ChewieCompliance-Normal', values: 'normal' },
        { id: 'bad', name: 'ChewieCompliance-Bad', values: 'bad' },
        { id: 'na', name: 'ChewieCompliance-NotUsed', values: 'na' },
    ]

    arrayChewiePassed = [
        { id: 0, name: 'ChewiePassed-None', values: '0' },
        { id: 1, name: 'ChewiePassed-1', values: '1' },
        { id: 2, name: 'ChewiePassed-2', values: '2' },
        { id: 3, name: 'ChewiePassed-3', values: '3' },
        { id: 4, name: 'ChewiePassed-4', values: '4' },
    ]

    arrayElasticCompliance = [
        { id: 'good', name: 'ElasticCompliance-Good', values: 'good' },
        { id: 'normal', name: 'ElasticCompliance-Normal', values: 'normal' },
        { id: 'bad', name: 'ElasticCompliance-Bad', values: 'bad' },
        { id: 'na', name: 'ElasticCompliance-NotUsed', values: 'na' },
    ]

    arrayElasticCompliancePassed = [
        { id: 0, name: 'CompliancePassed-None', values: '0' },
        { id: 1, name: 'CompliancePassed-1', values: '1' },
        { id: 2, name: 'CompliancePassed-2', values: '2' },
        { id: 3, name: 'CompliancePassed-3', values: '3' },
        { id: 4, name: 'CompliancePassed-4', values: '4' },
    ]


    arrayElasticTypeLeft = [
        { id: 'red', name: '1/4 Heavy', values: 'red' },
        { id: 'germany', name: '3/16 Heavy', values: 'germany' },
        { id: '18medium', name: '1/8 Medium', values: '18medium' },
        { id: 'null', name: 'None', values: 'null' },
    ]

    arrayElasticRight = [
        { id: 'red', name: '1/4 Heavy', values: 'red' },
        { id: 'germany', name: '3/16 Heavy', values: 'germany' },
        { id: '18medium', name: '1/8 Medium', values: '18medium' },
        { id: 'null', name: 'None', values: 'null' },
    ]

    constructor(private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private _sharedService: SharedServices,
                private modalService: ModalService,
                private route: ActivatedRoute) {
        this.modalService.changeEmitted$.subscribe(
            success => {
                if (success[0] === 'activeAddCompliance') {
                    this.ModalNewCompliance = 'active'
                    this.idClient = success[1]
                    this.listClient = success[2]
                    this.listAligner = success[3]
                    this.optionArrCopyAligner = this.listAligner.slice() // copy of optionArr
                    this.startDate = moment(this.listClient.alignerParam['startDate']).format('YYYY.MM.DD')
                    this.endDate = moment(this.listClient.alignerParam['endDate']).format('YYYY.MM.DD')
                    this.phaseAligner = this.ordinalSuffixOf(this.listClient.alignerParam['phase'])
                    this.activeAligner = this.listClient.activeAligner
                    this.defaultStaff = undefined
                    this.styleVisibility = { visibility: 'hidden' }

                } else if (success[0] === 'activeAddComplianceOrthoPulse') {
                    this.ModalNewCompliance = 'active'
                    this.idClient = success[1]
                    if (success[2] === 'ratio') {
                        this.ratioInput = 'active'
                    }
                    this.listClient = success[3]
                    this.listAligner = success[4]
                    this.optionArrCopyAligner = this.listAligner.slice() // copy of optionArr
                    this.startDate = moment(this.listClient.alignerParam['startDate']).format('YYYY.MM.DD')
                    this.endDate = moment(this.listClient.alignerParam['endDate']).format('YYYY.MM.DD')
                    this.phaseAligner = this.ordinalSuffixOf(this.listClient.alignerParam['phase'])
                    this.activeAligner = this.listClient.activeAligner
                } else if (success[0] === 'activeCompliceEdit') {
                    this.ModalEditCompliance = 'active'
                    if (success[2]) {
                        this.idClient = success[2].clientId
                        this.detailComplice = success[2]
                        if (success[3] === 'ratio') {
                            this.ratioInput = 'active'
                        }
                        this.activeAligner = success[4]
                        this.listAligner = success[5]
                        const activeAlignerInfo = this.listAligner.find(x => x._id === this.activeAligner)
                        if (activeAlignerInfo) {
                            this.startDate = moment(activeAlignerInfo['createTime']).format('YYYY.MM.DD')
                            this.endDate = moment(activeAlignerInfo['endDate']).format('YYYY.MM.DD')
                            this.phaseAligner = this.ordinalSuffixOf(activeAlignerInfo['phase'])
                        }
                        this.fillDataDetailComplice(this.detailComplice)
                    }
                } else if (success[0] === 'activeFilterAlignerCompliance') {
                    this.hiddenModalFilterAligner = 'active'
                    this.listAlignerCompliance = success[1]
                    // this.idClient = success[1];
                    // if (success[2] === 'ratio') {
                    //     this.ratioInput = 'active';
                    // }
                }
            })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    ordinalSuffixOf(i) {
        if (!i) {
            return ''
        }
        return ordinalSuffixOf(i)
    }

//   client-compliance

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        if (keyPressed === 27) {
            if (this.thisView == this.view) {
                if (this.ModalNewCompliance === 'active') {
                    // if (this.isShowConfirm == false) {
                    const emit: any = {}
                    emit['status'] = 'show'
                    emit['view'] = 'client-compliance'
                    this._sharedService.emitChangeIsShowConfirm(emit)
                    event.preventDefault()
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i == 0) {
                                emit['status'] = 'hide'
                                emit['view'] = 'client-compliance'
                                this._sharedService.emitChangeIsShowConfirm(emit)
                            } else if (i === 1) {
                                this.dialogNewCompliance = 'hidden'
                                this.ModalNewCompliance = 'hidden'
                                emit['status'] = 'hide'
                                emit['view'] = 'client-compliance'
                                this._sharedService.emitChangeIsShowConfirm(emit)
                            }
                        },
                    })
                    // }
                } else if (this.ModalEditCompliance === 'active') {
                    // if (this.isShowConfirm == false) {
                    const emit: any = {}
                    emit['status'] = 'show'
                    emit['view'] = 'client-compliance'
                    this._sharedService.emitChangeIsShowConfirm(emit)
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i == 0) {
                                emit['status'] = 'hide'
                                emit['view'] = 'client-compliance'
                                this._sharedService.emitChangeIsShowConfirm(emit)
                            } else if (i === 1) {
                                this.dialogEditCompliance = 'hidden'
                                this.ModalEditCompliance = 'hidden'
                                this.hidenModalNewComplice()
                                emit['status'] = 'hide'
                                emit['view'] = 'client-compliance'
                                this._sharedService.emitChangeIsShowConfirm(emit)
                            }
                        },
                    })
                    // }
                }
            } else if (this.view == 'modal-client-compliance') {
                if (this.hiddenModalAligner == 'active') {
                    this.hiddenModalAligner = 'hidden'
                    this.isShowConfirm = false
                    this.view = 'client-compliance'
                }
            } else if (this.view == 'compliance-staff') {
                if (this.showStaff == 'active') {
                    this.showStaff = 'hidden'
                    this.isShowConfirm = false
                    this.view = 'client-compliance'
                }
            } else if (this.view = 'compliance-all-aligner') {
                if (this.hiddenModalFilterAligner == 'active') {
                    const filterAlignerData = ['activeFilterAlignerCopl', '']
                    this._sharedService.emitChange(filterAlignerData)
                    this.hiddenModalFilterAligner = 'hidden'
                    const emit: any = {}
                    emit['status'] = 'hide'
                    emit['view'] = 'client-compliance'
                    this._sharedService.emitChangeIsShowConfirm(emit)
                }
            }

        }
    }

    fillDataDetailComplice(DataDetailComplice) {

        this.compileIdEdit = DataDetailComplice._id
        this.valueAlignerFit = DataDetailComplice.alignerFit ? DataDetailComplice.alignerFit : null
        this.valueVisitDate = moment(DataDetailComplice.visitDate).format('YYYY.MM.DD ddd')
        this.timestampDate = DataDetailComplice.visitDate
        this.valueVisitDateApi = this.timestampDate
        this.valueUsage = DataDetailComplice.usageTime ? DataDetailComplice.usageTime : 0
        this.valueRatio = DataDetailComplice.accelerationRatio ? DataDetailComplice.accelerationRatio : 0
        this.StaffId = DataDetailComplice.staff
        this.defaultStaff = DataDetailComplice.staff
        this.valueStaff = DataDetailComplice.operator
        this.valueStaffDeleted = DataDetailComplice.deleted
        this.showOption = 'showOption_' + DataDetailComplice.staff
        if (DataDetailComplice.receiveDevice == 1) {
            this.valueReceiveDevice = true
            this.receiveDeviceClass = 'option_' + 0
        } else if (DataDetailComplice.receiveDevice == 0) {
            this.valueReceiveDevice = false
            this.receiveDeviceClass = 'option_' + 1
        }
        this.valuechewieCompliance = DataDetailComplice.chewieComplianceCheck
        this.chewieComplianceClass = 'option_' + DataDetailComplice.chewieComplianceCheck
        this.valueChewiePassed = DataDetailComplice.chewiePass
        this.ChewiePassedClass = 'option_' + DataDetailComplice.chewiePass
        this.valueElasticCompliance = DataDetailComplice.elasticComplianceCheck
        this.ElasticComplianceClass = 'option_' + DataDetailComplice.elasticComplianceCheck
        this.valueElasticPassed = DataDetailComplice.elasticPass
        this.ElasticCompliancePassedClass = 'option_' + DataDetailComplice.elasticPass
        this.valueAlignerFit = DataDetailComplice.alignerFit
        this.modelAlignerFit = DataDetailComplice.alignerFit
        this.valueElasticTypeLeft = DataDetailComplice.elasticTypeLeft
        this.ElasticTypeLeftClass = 'option_' + DataDetailComplice.elasticTypeLeft
        this.valueElasticTypeRight = DataDetailComplice.elasticTypeRight
        this.ElasticRightClass = 'option_' + DataDetailComplice.elasticTypeRight
        if (DataDetailComplice.deviceData) {
            this.alignerPreviewDigest = DataDetailComplice.deviceData
            this.readCsv(DataDetailComplice.deviceData)
        } else {
            this.alignerPreviewDigest = ''
            this.loadAlignerPreviewData = false
            this.alignerPreviewData = ''
        }

    }

    updateCompliece(id) {
        const clientId = {}
        const clientInfo = {}
        var result = '{"clientId":"' + this.idClient + '"}'
        var infoClient = this.idClient
        clientId[result] = true
        clientInfo[infoClient] = true

        const resourceData = {
            actions: [
                {
                    type: 'update',
                    id: id,
                    collection: 'clientCompliance',
                    value: {
                        clientId: this.idClient,
                        createTime: Date.now(),
                        alignerFit: this.valueAlignerFit,
                        chewieCompliance: this.valuechewieCompliance,
                        chewiePass: this.valueChewiePassed,
                        elasticTypeLeft: this.valueElasticTypeLeft,
                        elasticTypeRight: this.valueElasticTypeRight,
                        elasticCompliance: this.valueElasticCompliance,
                        elasticPass: this.valueElasticPassed,
                        receiveDevice: this.valueReceiveDevice,
                        staff: this.StaffId,
                        targetAligner: this.activeAligner,
                        usageTime: this.valueUsage,
                        accelerationRatio: this.valueRatio,
                        visitDate: this.valueVisitDateApi,
                        updateTime: Date.now(),
                        deviceData: this.alignerPreviewDigest,
                    },
                },
            ],

            status: {
                client: {
                    map: {
                        map: clientInfo,
                    },
                },
                clientAligner: {
                    paths: clientId,
                },
                clientCompliance: {
                    paths: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(
                success => {
                    this.hidenModalNewComplice()
                    var listClientComplianceData = success['response']['clientCompliance']['paths'][result]
                    var listStaffData = success['response']['staff']['paths']['{}']
                    const listClientComplianceDataReturn = [listClientComplianceData, listStaffData]
                    this._sharedService.emitChangeParent(listClientComplianceDataReturn)
                },
            )
        })
    }


    removeCompliece(id) {
        const clientId = {}
        const clientInfo = {}
        var result = '{"clientId":"' + this.idClient + '"}'
        var infoClient = this.idClient
        clientId[result] = true
        clientInfo[infoClient] = true

        const resourceData = {
            actions: [
                {
                    type: 'remove',
                    id: id,
                    collection: 'clientCompliance',
                },
            ],

            status: {
                client: {
                    map: {
                        map: clientInfo,
                    },
                },
                clientAligner: {
                    paths: clientId,
                },
                clientCompliance: {
                    paths: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(
                success => {
                    this.hidenModalNewComplice()
                    var listClientComplianceData = success['response']['clientCompliance']['paths'][result]
                    var listStaffData = success['response']['staff']['paths']['{}']
                    const listClientComplianceDataReturn = [listClientComplianceData, listStaffData]
                    this._sharedService.emitChangeParent(listClientComplianceDataReturn)
                },
            )
        })
    }


    // hiden modal
    hidenModalNewCompliance() {
        this.ModalNewCompliance = 'hidden'
    }

    ngOnInit() {
        this.validatorForm()

        this._sharedService.changeEmittedIsShowConfirm$.subscribe(confirm => {
            if (confirm != null && confirm != undefined && confirm['status'] != undefined) {
                if (confirm['status'] == 'show') {
                    this.isShowConfirm = true
                    this.view = confirm['view']
                } else {
                    this.isShowConfirm = false
                    this.view = confirm['view']
                }
            }
        })
    }

    toggleReceiveDeviceItem(id, event) {
        if (this.receiveDeviceClass == id) {
            this.receiveDeviceClass = ''
        } else {
            this.receiveDeviceClass = id
        }
        this.valueReceiveDevice = event.target.value
        if (event.target.value == 0) {
            this.valueReceiveDevice = false
        } else {
            this.valueReceiveDevice = true
        }

        this.markAsDirty()
    }

    toggleComplianceItem(id, event) {
        if (this.chewieComplianceClass === id) {
            this.chewieComplianceClass = ''
            this.valuechewieCompliance = null
        } else {
            this.chewieComplianceClass = id
            this.valuechewieCompliance = event.target.value
        }
        this.markAsDirty()

    }

    toggleChewiePassedItem(id, event) {
        if (this.ChewiePassedClass == id) {
            this.ChewiePassedClass = ''
            this.valueChewiePassed = null
        } else {
            this.ChewiePassedClass = id
            this.valueChewiePassed = event.target.value
        }
        this.markAsDirty()

    }

    toggleElasticComplianceItem(id, event) {
        if (this.ElasticComplianceClass == id) {
            this.ElasticComplianceClass = ''
            this.valueElasticCompliance = null
        } else {
            this.ElasticComplianceClass = id
            this.valueElasticCompliance = event.target.value
        }
        this.markAsDirty()

    }

    toggleElasticCompliancePassedItem(id, event) {
        if (this.ElasticCompliancePassedClass == id) {
            this.ElasticCompliancePassedClass = ''
            this.valueElasticPassed = null
        } else {
            this.ElasticCompliancePassedClass = id
            this.valueElasticPassed = event.target.value
        }
        this.markAsDirty()

    }


    toggleElasticTypeLeftItem(id, event) {
        if (this.ElasticTypeLeftClass == id) {
            this.ElasticTypeLeftClass = ''
            this.valueElasticTypeLeft = null
        } else {
            this.ElasticTypeLeftClass = id
            this.valueElasticTypeLeft = event.target.value
        }
    }

    toggleElasticRightItem(id, event) {
        if (this.ElasticRightClass == id) {
            this.ElasticRightClass = ''
            this.valueElasticTypeRight = null
        } else {
            this.ElasticRightClass = id
            this.valueElasticTypeRight = event.target.value
        }
    }


    selectOptionStaff(id, value) {
        this.showOption = 'showOption_' + id
        this.defaultStaff = id
        if (this.showOption) {
            this.valueStaff = value
            this.valueStaffDeleted = undefined
            this.StaffId = id
            this.styleVisibility = { visibility: 'visible' }
            this.closeModalShowStaff()
        }
    }


    search(): void {
        const term = this.filterLang
        this.arrStaff = this.optionArrCopy.filter(function(tag) {
            return tag.firstName && tag.firstName.indexOf(term) >= 0 || tag.familyName && tag.familyName.indexOf(term) >= 0
        })
    }

    clickStaff() {
        this.showStaff = 'active'
        this.isShowConfirm = false
        this.view = 'compliance-staff'
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                    searches: {
                        '{"deleted": {"$ne": true}}': true
                    }
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    this.arrStaff = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                    this.optionArrCopy = this.arrStaff.slice()

                    if (this.defaultStaff) {
                        this.showOption = 'showOption_' + this.defaultStaff
                        this.styleVisibility = { visibility: 'visible' }
                    }
                    if (this.arrStaff) {
                        this.arrStaff.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)

                    }
                },
            )
        })

    }

    closeModalShowStaff() {
        this.showStaff = 'hidden'
        this.markAsDirty()
    };

    validatorForm() {
        this.complianceForm = this.formBuider.group({
            visitDate: '',
            usageTime: '',
            chewiePass: '',
            elasticCompliance: '',
            elasticPass: '',
            alignerFit: '',
        })
    }

    showVisitDate(event) {
        if (event) {
            const setTimestamp = moment(event['_d'])
            setTimestamp.set({ hours: 10 })
            const timestamp = moment(setTimestamp).utc().startOf('day').valueOf()
            this.valueVisitDate = moment(setTimestamp).format('YYYY.MM.DD ddd')
            this.timestampDate = timestamp
            this.valueVisitDateApi = timestamp
        } else {
            this.valueVisitDate = moment(Date.now()).format('YYYY.MM.DD ddd')
            this.timestampDate = Date.now()
            this.valueVisitDateApi = this.timestampDate
        }
    }

    nextDate(timestampAdd, day) {
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.valueVisitDate = showdateAdd
        this.valueVisitDateApi = timestampDate
        this.markAsDirty()

    }

    prevDate(timestampAdd, day) {
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.valueVisitDate = showdateAdd
        this.valueVisitDateApi = timestampDate
        this.markAsDirty()

    }

    prevUsage(valueUsageCurent, day) {
        if (parseInt(valueUsageCurent) > 0) {
            this.valueUsage = parseInt(valueUsageCurent) - parseInt(day)
        } else {
            this.valueUsage = 0
        }
        this.markAsDirty()


    }

    nextUsage(valueUsageCurent, day) {
        if (parseInt(valueUsageCurent) < 24) {
            this.valueUsage = parseInt(valueUsageCurent) + parseInt(day)
        } else {
            this.valueUsage = 24
        }
    }

    changevalueUsage(valueUsageChange) {
        if (valueUsageChange) {
            this.valueUsageCurent = this.valueUsage = parseInt(valueUsageChange)
        } else {
            this.valueUsageCurent = this.valueUsage = 0
        }
        this.markAsDirty()

    }


    prevRatio(valueRatioCurent, day) {
        if (parseInt(valueRatioCurent) > 0) {
            this.valueRatio = parseInt(valueRatioCurent) - parseInt(day)
        } else {
            this.valueRatio = 0
        }
        this.markAsDirty()
    }

    nextRatio(valueRatioCurent, day) {
        if (parseInt(valueRatioCurent) < 100) {
            this.valueRatio = parseInt(valueRatioCurent) + parseInt(day)
        } else {
            this.valueRatio = 100
        }
        this.markAsDirty()

    }

    changevalueRatio(valueRatioCurent) {
        if (valueRatioCurent) {
            this.valueRatioCurent = this.valueRatio = parseInt(valueRatioCurent)
        } else {
            this.valueRatioCurent = this.valueRatio = 0
        }
    }


    alertLanguage() {
        this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    }

    changeAlignerFit(event) {
        this.valueAlignerFit = event
    }

    hidenModalNewComplice() {
        this.ModalNewCompliance = 'hidden'
        this.ModalEditCompliance = 'hidden'
        this.ratioInput = 'hidden'
        this.valueAlignerFit = null
        this.modelAlignerFit = undefined
        this.valueVisitDate = moment(Date.now()).format('YYYY.MM.DD ddd')
        this.timestampDate = Date.now()
        this.valueVisitDateApi = this.timestampDate
        this.valueUsage = 0
        this.valueRatio = 0
        this.StaffId = undefined
        this.valueStaff = undefined
        this.valueStaffDeleted = undefined
        this.showOption = undefined
        this.valueReceiveDevice = undefined
        this.receiveDeviceClass = ''
        this.valuechewieCompliance = undefined
        this.chewieComplianceClass = ''
        this.valueChewiePassed = undefined
        this.ChewiePassedClass = ''
        this.valueElasticCompliance = undefined
        this.ElasticComplianceClass = ''
        this.valueElasticPassed = undefined
        this.ElasticCompliancePassedClass = ''
        this.valueElasticTypeLeft = undefined
        this.ElasticTypeLeftClass = ''
        this.valueElasticTypeRight = undefined
        this.ElasticRightClass = ''
        this.alignerPreviewDigest = ''
        this.loadAlignerPreviewData = false
        this.alignerPreviewData = ''
    }


    createNewCompliance() {
        const clientId = {}
        const clientInfo = {}
        var result = '{"clientId":"' + this.idClient + '"}'
        var infoClient = this.idClient
        clientId[result] = true
        clientInfo[infoClient] = true
        const resourceData = {
            actions: [
                {
                    type: 'create',
                    collection: 'clientCompliance',
                    value: {
                        clientId: this.idClient,
                        createTime: Date.now(),
                        alignerFit: this.valueAlignerFit,
                        chewieCompliance: this.valuechewieCompliance,
                        chewiePass: this.valueChewiePassed,
                        elasticTypeLeft: null,
                        elasticTypeRight: null,
                        elasticCompliance: this.valueElasticCompliance,
                        elasticPass: this.valueElasticPassed,
                        receiveDevice: this.valueReceiveDevice,
                        staff: this.StaffId,
                        targetAligner: this.activeAligner,
                        usageTime: this.valueUsage,
                        accelerationRatio: this.valueRatio,
                        visitDate: this.valueVisitDateApi,
                        deviceData: this.alignerPreviewDigest,
                    },
                },
            ],

            status: {
                client: {
                    map: {
                        map: clientInfo,
                    },
                },
                clientAligner: {
                    paths: clientId,
                },
                clientCompliance: {
                    paths: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(
                success => {
                    this.hidenModalNewComplice()
                    var listClientComplianceData = success['response']['clientCompliance']['paths'][result]
                    var listStaffData = success['response']['staff']['paths']['{}']
                    const listClientComplianceDataReturn = [listClientComplianceData, listStaffData]
                    this._sharedService.emitChangeParent(listClientComplianceDataReturn)
                },
            )
        })
    }

    editAligner() {
        const emit: any = {}
        emit['status'] = 'hide'
        emit['view'] = 'client-aligner'
        this._sharedService.emitChangeIsShowConfirm(emit)
        const arrAligner = {
            'action': 'editAligner',
            'clientId': this.idClient,
            'alignerId': this.activeAligner,
            'clientDetail': this.listClient,
        }
        this._sharedService.emitChange(arrAligner)
        this._sharedService.emitChange('editPaddingModal')
    }

    editAlignerComplicance() {
        this.hiddenModalAligner = 'active'
        const emit: any = {}
        this.isShowConfirm = false
        this.view = 'modal-client-compliance'
    }

    handleFileInput(files: FileList, event) {
        this.authData.authToken().then(tokenReNew => {
            this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                success => {

                    if (success['status'] == 'OK') {
                        this.readCsv(success['hash'])
                        this.alignerPreviewDigest = success['hash']
                    }
                },
            )
        })
    }

    readCsv(digest) {
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_get(imageStatusUrl + '/' + digest, tokenReNew).subscribe(success => {

                if (success['url']) {
                    this.restApi.http_get_csv(success['url'])
                    .subscribe(data => {

                        this.loadAlignerPreviewData = true
                        this.alignerPreviewData = data
                        // this.dataTest = data;
                    })
                }
            })
        })
    }

    openModalDetailData() {
        this.hiddenModalPreviewData = 'active'
    }

    removePreviewData() {
        this.hiddenModalPreviewData = 'hidden'
        this.alignerPreviewDigest = ''
        this.loadAlignerPreviewData = false
        this.alignerPreviewData = ''
    }

    editModalAligner(phase, createTime, endDate, idAligner) {
        this.startDate = moment(createTime).format('YYYY.MM.DD')
        this.endDate = moment(endDate).format('YYYY.MM.DD')
        this.phaseAligner = this.ordinalSuffixOf(phase)
        this.activeAligner = idAligner
        this.styleVisibilityAligner = { visibility: 'visible' }
        this.hiddenModalAligner = 'hidden'
    }

    // search language
    fitterAligner(): void {
        const term = this.paramsSearch
        this.listAligner = this.optionArrCopyAligner.filter(function(tag) {
            const _startDate = moment(tag.createTime).format('YYYY.MM.DD')
            const _endDate = moment(tag.endDate).format('YYYY.MM.DD')
            return _startDate && _startDate.indexOf(term) >= 0 || _endDate && _endDate.indexOf(term) >= 0 || tag.phase == term
        })
    }

    fitterAlignerCompliance(): void {
        const term = this.paramsSearchAligner
        this.listAlignerCompliance = this.optionArrCopyAlignerCompliance.filter(function(tag) {
            const _startDate = moment(tag.createTime).format('YYYY.MM.DD')
            const _endDate = moment(tag.endDate).format('YYYY.MM.DD')
            return _startDate && _startDate.indexOf(term) >= 0 || _endDate && _endDate.indexOf(term) >= 0 || tag.phase == term
        })
    }

    editModalAlignerFilter(idAligner, phase = null, createTime = null, endDate = null) {
        //
        let a = this.ordinalSuffixOf(phase) + ' (' + moment(createTime).format('YYYY.MM.DD') + '-' + moment(endDate).format('YYYY.MM.DD') + ')'
        this.hiddenModalFilterAligner = 'hidden'
        this.alignerActiveFilter = idAligner
        this._sharedService.emitChangeParent(['selectedIdFillter', idAligner, a])
    }

    markAsDirty() {
        this.complianceForm.markAsDirty()
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client/detail-client-compliance/modal-detail-client-compliance.component.ts